var $e7d2dd411722e939$exports = {};
$e7d2dd411722e939$exports = {
    "info": `Informacije`,
    "negative": `Gre\u{161}ka`,
    "notice": `Upozorenje`,
    "positive": `Uspe\u{161}no`
};


export {$e7d2dd411722e939$exports as default};
//# sourceMappingURL=sr-SP.mjs.map
